import { Container, ComponentWrapper } from "@/components";
import { cn } from "@/lib/utils";

const SPACING_TOP = {
  none: "pt-0",
  small: "pt-3 lg:pt-4",
  medium: "pt-6 lg:pt-8",
  large: "pt-10 lg:pt-12",
  extra_large: "pt-12 lg:pt-16",
};

const SPACING_BOTTOM = {
  none: "pb-0",
  small: "pb-3 lg:pb-4",
  medium: "pb-6 lg:pb-8",
  large: "pb-10 lg:pb-12",
  extra_large: "pb-12 lg:pb-16",
};

function resolveSpacingValue(spacing) {
  if (!spacing) return "medium";
  return typeof spacing === "object" ? spacing.value : spacing;
}

// Divider — horizontal red gum rule with container side padding
export function Divider({ type, spacingTop, spacingBottom }) {
  const topKey = resolveSpacingValue(spacingTop);
  const bottomKey = resolveSpacingValue(spacingBottom);

  return (
    <ComponentWrapper type={type}>
      <Container>
        <div
          className={cn(
            SPACING_TOP[topKey] ?? SPACING_TOP.medium,
            SPACING_BOTTOM[bottomKey] ?? SPACING_BOTTOM.medium
          )}
        >
          <hr className="m-0 border-0 border-t-2 border-brand-red-gum" />
        </div>
      </Container>
    </ComponentWrapper>
  );
}
